import React from 'react';
import {useRef} from 'react';
import PageTitle from '../components/pagetitle';
import emailjs from '@emailjs/browser';


function Contact(props) {
   
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_v89o5u9', 'template_pivm0nl', form.current, 'Gccy1mqxNMHwm5Shr')
          .then((result) => {
            
            form.current.reset();
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };

    return (
        <div>
            <PageTitle title='Contact Us' />
            <section className="tf-section tf-contact">
                <div className="container">
                    <div className="row">
                        <div className="center">
                            <div className="content-about m-b50 mobie-40" data-aos="fade-right" data-aos-duration="800">
                                <div className="tf-title st2 m-b17">
                                    <h4 className="title">Have a question </h4>
                                </div>
                                <p className="m-b40">Fill up the Form and the team will get back to within 24 hrs</p>
                            </div>
                            <form ref={form} onSubmit={sendEmail} className="form-contact" id="contactform" data-aos="fade-right" data-aos-duration="800">
                                <fieldset>
                                    <input type="text" name="user_name" id="name" placeholder="Name" />
                                </fieldset>
                                <fieldset>
                                    <input type="email" name="user_email" id="mail" placeholder="Email Address" />
                                </fieldset>
                                <fieldset>
                                    <textarea placeholder="Type your Messege" rows="5" tabIndex="4" name="message" className="message" id="message"></textarea>
                                </fieldset>
                                <button className="tf-button btn-effect" type="submit"><span className="boder-fade"></span><span className="effect">Send Message</span></button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;